export enum DetailsSharedActionPage {
  INSURED_PERSON = 'INSURED_PERSON',
  POLICY = 'POLICY',
  CASE = 'CASE',
  EXPERTISE_ATTACHMENT = 'EXPERTISE_ATTACHMENT',
  RIM = 'RIM',
  SVS = 'SVS',
  IMAGES = 'IMAGES',
  OTHER_ATTACHMENTS = 'OTHER_ATTACHMENTS',
  HONORARY_NOTE = 'HONORARY_NOTE',
  COMMENT_OR_REPORT = 'COMMENT_OR_REPORT',
  OVERVIEW = 'OVERVIEW',
  AGENDA = 'AGENDA',
}

export class SharedActionPage {
  page: DetailsSharedActionPage = DetailsSharedActionPage.OVERVIEW;
  previousPage: DetailsSharedActionPage = DetailsSharedActionPage.OVERVIEW;
  instructionId: number = 0;
}

export interface DocumentResponse {
  description: string;
  filename: string;
  url: string;
  amazonKey: string;
  bucketName: string;
  documentType: string;
  documentStatus: string;
  createdOn: string;
  createdByFirstName: string;
  createdByLastName: string;
  id: number;
  amazonId: string;
  subjectLine: string;
  reportStatusTC: string;
  isOnline: boolean;
  isForPreview: boolean;
  mimeType: string;
  approved?: boolean;
}

export interface DeleteDocumentRequest {
  id: number;
  amazonId: string;
  thumbAmazonId?: string;
}

export function createDeleteDocumentRequest(): DeleteDocumentRequest {
  return {
    id: 0,
    amazonId: '',
    thumbAmazonId: undefined
  };
} 

export interface DocumentRequest {
  filename: string;
  description: string;
  content: string;
  documentTypeTC: string;
  subjectLine: string;
  reportStatusTC: string;
}

export function createDocumentRequest(): DocumentRequest {
  return {
    filename: '',
    description: '',
    content: '',
    documentTypeTC: '',
    subjectLine: '',
    reportStatusTC: ''
  };
}

export interface CaseDocumentsRequest {
  claimNotificationId: number;
  documents: DocumentRequest[];
}

export function createCaseRequest(): CaseDocumentsRequest {
  return {
    claimNotificationId: 0,
    documents: [],
  };
}

export interface ImageResponse {
  thumbUrl: string;
  thumbAmazonId: string;
  bucketName: string;
  description: string;
  filename: string;
  url: string;
  amazonKey: string;
  documentType: string;
  documentStatus: string;
  createdOn: string;
  createdByFirstName: string;
  createdByLastName: string;
  id: number;
  amazonId: string;
  subjectLine: string;
  reportStatusTC: string;
  isOnline: boolean;
  isForPreview: boolean;
  mimeType: string;
  approved?: boolean;
}

export interface UpdateImageRequest {
  id: number;
  content?: string;
  filename?: string;
  description?: string;
  documentStatus?: string;
}

export function createUpdateImageRequest(): UpdateImageRequest {
  return {
    id: 0,
    content: '',
    filename: '',
    description: '',
    documentStatus: ''
  };
}
